import React from 'react'

import { Spinner } from '~/components/landing-form/form-types/rounded/spinner'
import { pluralize } from '~/utils/string'
import { track } from '~/utils/tracking'

import styles from './styles.module.css'

const ShowDealsButton = ({ onClick, availableDealsCount, isOpen = false, isLoading = false }) => {
  const clickHandler = (e) => {
    track('Broadband - Filter & Sort', 'Show deals')
    onClick(e)
  }

  return (
    <div className={styles.wrapper} data-open={isOpen}>
      <button className={styles.button} onClick={clickHandler}>
        {isLoading ? (
          <Spinner wrapperStyles={styles.spinnerWrapper} spinnerStyles={styles.spinner} />
        ) : (
          <span className={styles.label}>
            Show {availableDealsCount} {pluralize('deal', availableDealsCount)}
          </span>
        )}
      </button>
    </div>
  )
}

export default ShowDealsButton
